
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["venn-demo-common","venn-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Venn__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.en.md?type=demo')
};